import { render, staticRenderFns } from "./ProfileStatusDropdown.vue?vue&type=template&id=2684f800&scoped=true"
import script from "./ProfileStatusDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileStatusDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProfileStatusDropdown.vue?vue&type=style&index=0&id=2684f800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684f800",
  null
  
)

export default component.exports